module.exports = __webpack_public_path__ + "img/CY120018.a1c2f1e6.png";